/* BIA full-screen image viewer.
   Replaces the older bp__zoom dialog on product pages. The click is captured
   before the legacy handler so only one viewer ever opens.
   Pinch zoom is native (touch-action: pinch-zoom) on a full-width source — not
   a CSS scale of a small file. Closing restores the image you ended on and the
   page scroll position. Not required to browse or buy. */
(function () {
  var viewer = null, opener = null, restoreY = 0, slides = [], raf = null;

  function current() {
    var t = viewer.querySelector('[data-bview-track]');
    var w = t.clientWidth || 1;
    return Math.max(0, Math.min(slides.length - 1, Math.round(t.scrollLeft / w)));
  }

  function count() {
    if (!viewer || !slides.length) return;
    var c = viewer.querySelector('[data-bview-count]');
    if (!c) return;
    var i = current();
    c.textContent = ('0' + (i + 1)).slice(-2) + ' / ' + ('0' + slides.length).slice(-2);
  }

  function onKey(e) {
    if (!viewer || !viewer.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      e.preventDefault();
      var t = viewer.querySelector('[data-bview-track]');
      t.scrollBy({ left: (e.key === 'ArrowRight' ? 1 : -1) * t.clientWidth, behavior: 'smooth' });
    }
  }

  function build() {
    if (viewer) return viewer;
    viewer = document.createElement('div');
    viewer.className = 'bview';
    viewer.setAttribute('role', 'dialog');
    viewer.setAttribute('aria-modal', 'true');
    viewer.setAttribute('aria-label', 'Image viewer');
    viewer.innerHTML =
      '<div class="bview__bar">' +
        '<span class="bview__count" data-bview-count aria-live="polite"></span>' +
        '<button class="bview__x" type="button" data-bview-close aria-label="Close image viewer">&times;</button>' +
      '</div>' +
      '<div class="bview__track" data-bview-track></div>' +
      '<p class="bview__hint">Pinch to zoom &middot; swipe to browse</p>';
    document.body.appendChild(viewer);
    viewer.querySelector('[data-bview-close]').addEventListener('click', close);
    viewer.querySelector('[data-bview-track]').addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; count(); });
    }, { passive: true });
    document.addEventListener('keydown', onKey);
    return viewer;
  }

  function open(figs, index, trigger) {
    build();
    opener = trigger || null;
    restoreY = window.scrollY || window.pageYOffset || 0;
    slides = figs;
    var track = viewer.querySelector('[data-bview-track]');
    track.innerHTML = figs.map(function (f, i) {
      var im = f.querySelector('img');
      var src = f.getAttribute('data-bp-zoomsrc') || (im && (im.currentSrc || im.src)) || '';
      var alt = (f.getAttribute('data-bp-zoomalt') || '').replace(/"/g, '');
      return '<div class="bview__s"><img src="' + src + '" alt="' + alt + '" ' +
        (i === index ? 'fetchpriority="high"' : 'loading="lazy"') +
        ' decoding="async" draggable="false"></div>';
    }).join('');

    viewer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    track.scrollLeft = index * (track.clientWidth || window.innerWidth);
    count();
    requestAnimationFrame(function () {
      track.scrollLeft = index * (track.clientWidth || window.innerWidth);
      count();
    });
    var x = viewer.querySelector('[data-bview-close]');
    if (x) x.focus();
  }

  function close() {
    if (!viewer || !viewer.classList.contains('is-open')) return;
    var i = current();
    viewer.classList.remove('is-open');
    document.body.style.overflow = '';
    var fig = slides[i];
    if (fig) {
      var gal = fig.closest('[data-bp-gal]');
      if (gal && window.innerWidth < 1000) { try { gal.scrollLeft = fig.offsetLeft; } catch (e) {} }
    }
    window.scrollTo(0, restoreY);
    if (opener && opener.focus) opener.focus();
    slides = [];
  }

  /* capture phase: run before the legacy bp__zoom handler and stop it */
  document.addEventListener('click', function (e) {
    var fig = e.target.closest ? e.target.closest('[data-bp-zoomsrc]') : null;
    if (!fig) return;
    var gal = fig.closest('[data-bp-gal]');
    if (!gal) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var figs = Array.prototype.slice.call(gal.querySelectorAll('[data-bp-zoomsrc]'));
    open(figs, Math.max(0, figs.indexOf(fig)), fig);
  }, true);

  /* keep the legacy dialog shut if anything else opens it */
  document.addEventListener('click', function () {
    var old = document.querySelector('dialog[data-bp-zoom][open]');
    if (old && old.close) { try { old.close(); } catch (e) {} }
  }, true);
})();
